/* ODI · «Espalda (Oswestry)» · cuánto le limita el dolor en su vida.
   CLONADO de FisioVisión (prototipo/paciente.html · pintarODI, 13-ago-2026).
   Tocadas SOLO las dos cosas que permite la norma: de dónde entran los datos
   (por parámetro) y dónde se pinta (devuelve el HTML). Y «Thais» pasa a ser
   SU fisio. Ver NORMA_CLONAR_NO_INVENTAR.md.

   ⚠️ LO QUE HAY QUE ENTENDER DE ESTA ESCALA, y está en el prototipo:
   AQUÍ LA CIFRA BUENA ES LA QUE BAJA. Un 18% suena a suspenso y es una
   noticia buenísima. Por eso al paciente NO se le enseña el porcentaje como
   dato principal, sino CUÁNTO HA RECUPERADO.

   · sin las 8 secciones contestadas NO hay resultado: un porcentaje calculado
     a medias es un número falso con pinta de verdadero
   · la barra solo sale si ha mejorado: una barra a cero es un suspenso en la
     cara, y aquí no se suspende a nadie
   · las palabras del encargo, SIN puntos y SIN la palabra «discapacidad» */

function fechaCorta(iso){
  try{ return new Date(String(iso).slice(0,10)+'T00:00:00').toLocaleDateString('es-ES',{day:'numeric',month:'long'}); }
  catch(e){ return iso; }
}
function NOMBRE(f){ return (f && f.nombre) ? String(f.nombre).split(' ')[0] : 'tu fisio'; }

var ODI_SEC = [
  { n:'Intensidad del dolor',  ico:'<path d="M20.8 6.6a5 5 0 00-8.8-2 5 5 0 00-8.8 2c-.9 3.6 3 7.4 8.8 11.4 5.8-4 9.7-7.8 8.8-11.4z"/>' },
  { n:'Cuidados personales',   ico:'<path d="M4 13h16v3a4 4 0 01-4 4H8a4 4 0 01-4-4v-3z"/><path d="M7 13V6a2 2 0 014 0"/>' },
  { n:'Levantar peso',         ico:'<path d="M3 9v6M6 7v10M18 7v10M21 9v6M6 12h12"/>' },
  { n:'Andar',                 ico:'<path d="M13 4.5a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z"/><path d="M9 21l2.5-5 2-2.5-1-4.5-3.5 2-1.5 3"/><path d="M12.5 9l3.5 1.5 2 3.5"/>' },
  { n:'Estar sentado',         ico:'<path d="M4 11v7M20 11v7M4 14h16"/><path d="M6 11V7a2 2 0 012-2h8a2 2 0 012 2v4"/>' },
  { n:'Estar de pie',          ico:'<circle cx="12" cy="4" r="1.7"/><path d="M12 7v8M9 21l3-6 3 6M8 10h8"/>' },
  { n:'Dormir',                ico:'<path d="M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z"/>' },
  { n:'Vida sexual',           ico:'<path d="M20.8 6.6a5 5 0 00-8.8-2 5 5 0 00-8.8 2c-.9 3.6 3 7.4 8.8 11.4 5.8-4 9.7-7.8 8.8-11.4z"/>' },
  { n:'Vida social',           ico:'<circle cx="9" cy="8" r="3"/><path d="M3 20a6 6 0 0112 0"/><path d="M16 6a3 3 0 010 6M18 20a6 6 0 00-3-5.2"/>' },
  { n:'Viajar',                ico:'<path d="M5 17h14M4 17v-4l2-5h12l2 5v4"/><circle cx="7.5" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/>' }
];

/* las palabras del encargo · sin puntos y sin la palabra «discapacidad» */
var ODI_PALABRA = ['Sin problema','Molestia leve','Algo limitada','Bastante limitada','Muy limitada','Muy limitada'];
var ODI_NIVEL   = [1,2,3,4,5,5];   /* a qué color de la escala de la casa va cada punto */

function odiPct(r){
  var puntos = 0, hechas = 0;
  r.s.forEach(function(v){ if(v !== null && v !== undefined){ puntos += v; hechas++; } });
  if(hechas < 8) return null;               /* con menos de 8, no hay resultado */
  return Math.round(puntos / (hechas * 5) * 100);
}
function odiFranja(p){
  return p <= 20 ? 'limitación mínima'
       : p <= 40 ? 'te limita algo'
       : p <= 60 ? 'te limita bastante'
       : p <= 80 ? 'te limita mucho'
                 : 'te limita muchísimo';
}

export default function odiHTML(ODI_HIST, FISIO){
  var h = (ODI_HIST || []).slice().sort(function(a,b){ return new Date(a.fecha)-new Date(b.fecha); });
  if(!h.length) return '';

  var hoy = h[h.length-1], inicial = h[0];
  var pHoy = odiPct(hoy), pIni = odiPct(inicial);
  if(pHoy === null) return '';

  var hayHistoria = h.length > 1 && pIni !== null;
  var mejor = hayHistoria && pHoy < pIni;
  var recup = (hayHistoria && pIni > 0) ? Math.round((pIni - pHoy) / pIni * 100) : 0;

  var frase = !hayHistoria
    ? ('Esto le sirve a '+NOMBRE(FISIO)+' para saber cuánto te limita la espalda.')
    : (mejor ? 'Tu espalda te limita cada vez menos. Aquí la cifra importante baja: menos es mejor.'
      : pHoy === pIni ? ('De momento se mantiene igual. '+NOMBRE(FISIO)+' lo tiene en cuenta.')
      : 'Hoy ha sido un día más difícil. Se lo comentamos a tu fisio.');

  var filas = ODI_SEC.map(function(sec, i){
    var v = hoy.s[i];
    if(v === null || v === undefined) return '';    /* omitida: no se inventa */
    return '<div class="fv-eq__fila">'+
      '<svg class="fv-eq__ico" width="19" height="19" viewBox="0 0 24 24" fill="none" '+
        'stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'+sec.ico+'</svg>'+
      '<span class="fv-eq__que">'+sec.n+'</span>'+
      '<span class="fv-eq__nivel n'+ODI_NIVEL[v]+'">'+ODI_PALABRA[v]+'</span>'+
    '</div>';
  }).join('');

  return (
    '<div class="fv-eq">'+
      '<div class="fv-eva__cab">'+
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="3"/><path d="M12 10v11M8 14h8"/></svg>'+
        '<div><b>Espalda (Oswestry)</b><small>Lo que contestaste el '+fechaCorta(hoy.fecha)+'</small></div>'+
      '</div>'+
      '<p class="fv-eq__saludo">'+frase+'</p>'+

      (hayHistoria
        ? '<div class="fv-eq__antes">'+
            '<div><small>Al empezar</small><b>'+pIni+'<i>%</i></b><em>'+odiFranja(pIni)+'</em></div>'+
            '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M13 6l6 6-6 6"/></svg>'+
            '<div><small>Hoy</small><b class="'+(mejor?'es-mejor':'')+'">'+pHoy+'<i>%</i></b><em>'+odiFranja(pHoy)+'</em></div>'+
          '</div>'
        : '')+

      /* la barra SOLO si ha mejorado · una barra a cero es un suspenso
         en la cara, y aquí no se suspende a nadie */
      (recup > 0
        ? '<div class="fv-eq__caja">'+
            '<div class="fv-eq__barra"><i style="width:'+recup+'%"></i></div>'+
            '<small>Has recuperado el '+recup+'% de lo que el dolor te limitaba</small>'+
          '</div>'
        : '')+

      '<div class="fv-eq__lista">'+filas+'</div>'+
    '</div>');
}
